import { CaPageHeader, usePath } from "@/company-admin/shared";
import { StatusPill, Button } from "@/admin/ui";

export default function Departments() {
    const { data, loading } = usePath("/company-admin/departments");

    return (
        <div data-testid="ca-departments-page">
            <CaPageHeader
                title="Departments"
                subtitle="Enable or disable departments in your company. Assign employees and configure data forms."
            />

            {loading ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {Array.from({ length: 6 }).map((_, i) => <div key={i} className="glass rounded-3xl p-6 h-[180px] animate-pulse" />)}
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {(data || []).map((d) => (
                        <div key={d.id} data-testid={`ca-dept-${d.name.toLowerCase().replace(/\s+/g, "-")}`} className="glass rounded-3xl p-6 flex flex-col">
                            <div className="flex items-center justify-between">
                                <div className="font-display text-xl font-medium text-black">{d.name}</div>
                                <StatusPill status={d.active ? "active" : "inactive"} />
                            </div>
                            <div className="mt-1 text-[13px] text-neutral-500">{d.tag}</div>

                            <div className="mt-5 grid grid-cols-2 gap-2 text-[12px]">
                                <div className="rounded-xl bg-white border border-black/5 px-3 py-2">
                                    <div className="text-[10px] tracking-[0.18em] uppercase text-neutral-500">Employees</div>
                                    <div className="text-[15px] font-semibold text-black">{d.assigned_users || 0}</div>
                                </div>
                                <div className="rounded-xl bg-white border border-black/5 px-3 py-2">
                                    <div className="text-[10px] tracking-[0.18em] uppercase text-neutral-500">Access</div>
                                    <div className="text-[13px] font-semibold text-black capitalize">{d.data_access_level || "standard"}</div>
                                </div>
                            </div>

                            <div className="mt-5 flex items-center justify-between gap-2">
                                <Button
                                    variant="ghost" size="sm"
                                    onClick={() => alert("Assigning users happens from Employees → set Department. Configure forms is coming soon.")}
                                >
                                    Assign / Configure
                                </Button>
                                <span className="text-[11px] text-neutral-500">
                                    {d.active ? "Ready" : "Disabled by platform admin"}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="mt-8 glass rounded-3xl p-5 text-[13px] text-neutral-600">
                <span className="text-violet-600 font-semibold">Note:</span> The list of departments is managed platform-wide. If a department is disabled it can’t be enabled from here — ask your platform admin to enable it globally first.
            </div>
        </div>
    );
}
